"use client";

import React, {useState, useEffect} from 'react';

import type {Metadata} from 'next';

import Image from 'next/image';

import {AppRouterCacheProvider} from '@mui/material-nextjs/v15-appRouter';
import {Geist, Geist_Mono, Roboto} from 'next/font/google';
import {ThemeProvider, CssVarsProvider, createTheme, useColorScheme} from '@mui/material/styles';
import {CssBaseline, AppBar, Container, Toolbar, Box, Button} from '@mui/material';
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';

import theme from '../theme';
import {AuthProvider} from '@/app/_contexts/AuthContext';
import {AuthStatusProvider} from '@/app/_contexts/AuthStatusContext';
import MenuButtons from '@/app/_components/MenuButtons';
import ThemeButtons from '@/app/_components/ThemeButtons';
import AuthButtons from '@/app/_components/AuthButtons';


const geistSans = Geist({
    variable: "--font-geist-sans",
    subsets: ["latin"],
});

const geistMono = Geist_Mono({
    variable: "--font-geist-mono",
    subsets: ["latin"],
});


const metadata: Metadata = {
    title: "Spherical",
    description: "Spherical",
};


export default function RootLayout({children,}: Readonly<{ children: React.ReactNode; }>) {
    return (
        <html lang="en" suppressHydrationWarning>
        <head>
            <meta charSet="utf-8"/>
            <meta name="viewport" content="width=device-width, initial-scale=1"/>
            <title>{String(metadata.title || 'Spherical')}</title>
            <meta name="description" content={String(metadata.description || 'Spherical')}/>
        </head>
        {/* <body className={`${geistSans.variable} ${geistMono.variable} antialiased`}> */}
        <body>
        <AuthProvider>
            <AppRouterCacheProvider options={{enableCssLayer: true}}>
                <ThemeProvider theme={theme} disableTransitionOnChange>
                    <InitColorSchemeScript attribute="class"/>
                    <CssBaseline enableColorScheme/>
                    <AuthStatusProvider>
                        <AppBar
                            position="static"
                            sx={[
                                (theme) => ({
                                    backgroundColor: theme.vars.palette.background.default,
                                }),
                                (theme) =>
                                    theme.applyStyles('light', {
                                        backgroundColor: theme.vars.palette.background.default,
                                    }),
                                (theme) =>
                                    theme.applyStyles('dark', {
                                        backgroundColor: theme.vars.palette.background.default,
                                    }),
                            ]}
                        >
                            <Container maxWidth="xl">
                                <Toolbar>
                                    <Button size="large" href="/" sx={{mx: 2}}>
                                        {/*<Image*/}
                                        {/*    src="/Spherical_Logos/Logo_on_Dark_background_2.png"*/}
                                        {/*    height={50}*/}
                                        {/*    width={50}*/}
                                        {/*    alt="Spherical_Logos"*/}
                                        {/*/>*/}
                                        {/*<Image*/}
                                        {/*    src="/Spherical_Logos/Logo_on_white_or_light_background.png"*/}
                                        {/*    height={50}*/}
                                        {/*    width={50}*/}
                                        {/*    alt="Spherical_Logos"*/}
                                        {/*/>*/}
                                        <LandingPageLogo />
                                    </Button>
                                    <Box sx={{flexGrow: 1}}>
                                        <MenuButtons/>
                                    </Box>
                                    <Box sx={{mx: 2}}>
                                        <ThemeButtons/>
                                    </Box>
                                    <Box>
                                        <AuthButtons/>
                                    </Box>
                                </Toolbar>
                            </Container>
                        </AppBar>
                        {children}
                    </AuthStatusProvider>
                </ThemeProvider>
            </AppRouterCacheProvider>
        </AuthProvider>
        </body>
        </html>
    );
}
